// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8cf77e74","239":"2cd370fb","256":"ac12a869","455":"a3471e99","859":"49635fb0","965":"ea0ac3a7","977":"eb3cec7c"}[chunkId] + ".chunk.js";
};